import React from 'react';
import { Modal, ModalBody } from 'reactstrap';

import { EventStatus } from 'types';

import { ReactComponent as Archive } from '../../../assets/svg/archive.svg';

interface ArchiveModalProps {
  show: boolean;
  title: string;
  eventStatus: EventStatus;
  onDeleteClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
  onCloseClick: React.MouseEventHandler | undefined;
  disabled?: boolean;
}

const ArchiveModal = ({
  show,
  title,
  eventStatus,
  onDeleteClick,
  onCloseClick,
  disabled,
}: ArchiveModalProps) => {
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <div className='modal-content'>
        <ModalBody className='px-4 py-5 text-center'>
          <button
            type='button'
            onClick={onCloseClick}
            className='btn-close position-absolute end-0 top-0 m-3'
          ></button>
          <div className='avatar-sm mb-4 mx-auto'>
            <div className='avatar-title bg-danger text-danger bg-opacity-10 font-size-20 rounded-3'>
              <Archive width={16} height={16} fill='#CA5040' />
            </div>
          </div>
          <p className='text-muted font-size-16 mb-4'>{title}</p>
          {eventStatus === EventStatus.ON_EVENT ? (
            <p className='text-muted mb-4'>
              When you archive, this event
              <span className='tw-text-[#D0342C] tw-font-bold'> must be verified </span> again!
            </p>
          ) : (
            <p className='text-muted mb-4'>Are you sure you want to archive this event?</p>
          )}

          <div className='hstack gap-3 justify-content-center mb-0'>
            <button
              type='button'
              disabled={disabled}
              className='btn btn-danger'
              onClick={onDeleteClick}
            >
              Archive
            </button>
            <button type='button' className='btn btn-secondary' onClick={onCloseClick}>
              Close
            </button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  );
};

export default ArchiveModal;
